import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import {getAnalytics} from "firebase/analytics";



const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};



const app = initializeApp(firebaseConfig);

// console.log("Firebase initialized with config:", firebaseConfig);

// export const auth = getAuth(app);
export const db = getFirestore(app);
// console.log("Firestore initialized:", db);
export const analytics = getAnalytics(app);